import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ModalsContainer = _resolveComponent("ModalsContainer")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createBlock(_component_router_view, {
            key: _ctx.$route.fullPath
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ModalsContainer)
    ]),
    _: 1
  }))
}